<template>
  <div
    class="card px-2 py-2 mt-3 wrapper-hgsi"
    v-if="hgsiData.vendas.length > 0 || hgsiData.posvendas.length > 0"
  >
    <div>
      <button class="btn" style="box-shadow: none;" @click="visible = !visible">
        <i class="fab fa-buffer"></i>
        {{ this.reportName() }}
      </button>
      <button
        class="btn pull-right"
        style="box-shadow: none;"
        @click="visible = !visible"
      >
        <i class="fas fa-angle-double-right" v-if="!visible"></i>
        <i v-else class="fas fa-angle-double-down"></i>
      </button>
    </div>
    <div class="wrapper-hgsi card" v-if="loader">
      <div>
        <div class="loader d-flex justify-content-center align-items-center">
          <b-spinner
            variant="primary"
            type="grow"
            :label="`${this.$t('reports.loadingLabel')}...`"
          ></b-spinner>
        </div>
      </div>
    </div>
    <div v-else>
      <b-collapse v-model="visible" class="mt-2">
        <!-- VENDAS -->
        <div v-if="itemsVendas.length > 0">
          VENDAS
          <div style="display: flex;">
            <div class="hgsi-chart col-3">
              <radial-progress-bar
                v-if="vendasScore !== null && vendasScore !== undefined"
                :diameter="240"
                :stroke-width="20"
                innerStrokeColor="#f1f1f1"
                :startColor="colorBalanceS"
                :stopColor="colorBalanceS"
                :completed-steps="vendasScore ? parseInt(vendasScore) : 0"
                :total-steps="1000"
              >
                <b
                  id="hgsi-vendas"
                  v-b-modal.drilldownReport
                  :style="{
                    color: colorBalanceS,
                    fontSize: '2.8em',
                    fontWeight: 'bold',
                  }"
                  >{{ vendasScore }}
                  <drilldownReport
                    :answers="respostas"
                    :questions="hgsiData.vendas"
                    :title="`${this.reportTitle} Vendas`"
                  />
                </b>
                <b-tooltip
                  v-if="vendasScore !== null && vendasScore !== undefined"
                  target="hgsi-vendas"
                  placement="bottom"
                >
                  Vendas
                  <strong>{{ vendasScore }}</strong>
                </b-tooltip>
              </radial-progress-bar>
              <div v-else>
                Sem dados para exibir
              </div>
            </div>
            <b-table
              :items="itemsVendas"
              caption-bottom
              :fields="fields"
              sort-icon-left
            >
              <template v-slot:cell(progress)="row">
                <div class="mt-2">
                  <b-progress :value="row.item.progress" :max="1000">
                  </b-progress>
                </div>
              </template>
              <template v-slot:cell(score)="row">
                <div class="text-right">
                  {{ row.item.score }}
                </div>
              </template>
              <template v-slot:cell(total)="row">
                <div class="text-center">
                  {{ row.item.total }}
                </div>
              </template>
            </b-table>
          </div>
        </div>
        <!-- POSVENDAS -->
        <div v-if="itemsPosvendas.length > 0">
          PÓS-VENDAS
          <div style="display: flex;">
            <div class="hgsi-chart col-3">
              <radial-progress-bar
                v-if="posvendasScore !== null && posvendasScore !== undefined"
                :diameter="240"
                :stroke-width="20"
                innerStrokeColor="#f1f1f1"
                :startColor="colorBalanceAS"
                :stopColor="colorBalanceAS"
                :completed-steps="posvendasScore ? parseInt(posvendasScore) : 0"
                :total-steps="1000"
              >
                <b
                  id="hgsi-posvendas"
                  v-b-modal.drilldownReport
                  :style="{
                    color: colorBalanceAS,
                    fontSize: '2.8em',
                    fontWeight: 'bold',
                  }"
                  >{{ posvendasScore }}
                  <drilldownReport
                    :answers="respostas"
                    :questions="hgsiData.posvendas"
                    :title="`${this.reportTitle} Pós-Vendas`"
                  />
                </b>
                <b-tooltip
                  v-if="posvendasScore !== null && posvendasScore !== undefined"
                  target="hgsi-posvendas"
                  placement="bottom"
                >
                  Pós-Vendas
                  <strong>{{ posvendasScore }}</strong>
                </b-tooltip>
              </radial-progress-bar>
              <div v-else>
                Sem dados para exibir
              </div>
            </div>
            <b-table
              :items="itemsPosvendas"
              caption-bottom
              :fields="fields"
              sort-icon-left
            >
              <template v-slot:cell(progress)="row">
                <div class="mt-2">
                  <b-progress :value="row.item.progress" :max="1000">
                  </b-progress>
                </div>
              </template>
              <template v-slot:cell(score)="row">
                <div class="text-right">
                  {{ row.item.score }}
                </div>
              </template>
              <template v-slot:cell(total)="row">
                <div class="text-center">
                  {{ row.item.total }}
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import RadialProgressBar from 'vue-radial-progress';
import animatedNumber from 'animated-number-vue';
import api from '@/services/api';
import drilldownReport from '@/components/molecules/highcharts/reports/rankings/components/modal-drilldown';

export default {
  name: 'HgsiReport',
  components: {
    RadialProgressBar,
    animatedNumber,
    drilldownReport,
  },

  props: ['showCollapsed'],

  data: () => ({
    filter: null,
    userAuth: null,
    visible: true,
    page: 1,
    limit: 10,
    hgsiData: {
      vendas: [],
      posvendas: [],
    },
    loader: false,
    itemsVendas: [],
    itemsPosvendas: [],
    vendasScore: null,
    posvendasScore: null,
    fields: [],
    respostas: [],
    reportTitle: '',
    colorBalanceS: '#fff',
    colorBalanceAS: '#fff',
  }),

  watch: {
    actionGroupData: function watchActionGroupData() {
      this.mountHGSI();
    },
    myActionId: function watchMyActionId() {
      this.mountHGSI();
    },
    myActionsIds: function watchMyActionsIds() {
      this.mountHGSI();
    },
    myIh1: function watchMyIh1() {
      this.mountHGSI();
    },
    myHierarchies1: function watchMyHierarchies1() {
      this.mountHGSI();
    },
    myIh2: function watchMyIh2() {
      this.mountHGSI();
    },
    myHierarchies2: function watchMyHierarchies2() {
      this.mountHGSI();
    },
    calendarDates: function watchDates() {
      this.mountHGSI();
    },
    myMetric: function watchMyMetric() {
      this.mountHGSI();
    },
    'indicatorData.value': function watchMyMetric() {
      this.mountHGSI();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.mountHGSI();
    },
  },

  computed: {
    ...mapState('actions', ['myActionId','myActionsIds', 'actionGroupData', 'allActions']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['myIh1', 'myIh2', 'ih1', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  methods: {
    async mountHGSI() {
      this.loader = true;
      const response = await api.get(`reports/hgsi`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          companyId: this.userAuth.companyId,
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start ? this.calendarDates.start : null,
          endDate: this.calendarDates.end ? this.calendarDates.end : null,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
        },
      });
      this.hgsiData = response.data;
      this.respostas = this.hgsiData.respostas;
      // builds info for VENDAS
      this.itemsVendas = [];
      this.vendasScore = null;
      this.hgsiData.vendas.map((obj) => {
        this.itemsVendas.push({
          question: obj.question,
          progress: (obj.average * 100).toFixed(0),
          score: (obj.average * 100).toFixed(0),
          total: obj.total,
        });
        if (this.vendasScore) {
          this.vendasScore += obj.average;
        } else {
          this.vendasScore = obj.average;
        }
      });
      if (this.userAuth.companyId === '6107163db7c09a18a2663385') {
        this.vendasScore = (100 * this.hgsiData.vendasHgsi).toFixed(0);
      } else if (this.vendasScore) {
          this.vendasScore = (
            (100 * this.vendasScore) /
            this.hgsiData.vendas.length
          ).toFixed(0);
        }
      if (this.vendasScore) {
        this.setColorS(this.vendasScore);
      }
      // builds info for POSVENDAS
      this.itemsPosvendas = [];
      this.posvendasScore = null;
      this.hgsiData.posvendas.map((obj) => {
        this.itemsPosvendas.push({
          question: obj.question,
          progress: (obj.average * 100).toFixed(0),
          score: (obj.average * 100).toFixed(0),
          total: obj.total,
        });
        if (this.posvendasScore) {
          this.posvendasScore += obj.average;
        } else {
          this.posvendasScore = obj.average;
        }
      });
      if (this.userAuth.companyId === '6107163db7c09a18a2663385') {
        this.posvendasScore = (100 * this.hgsiData.posvendasHgsi).toFixed(0);
      } else if (this.posvendasScore) {
          this.posvendasScore = (
            (100 * this.posvendasScore) /
            this.hgsiData.posvendas.length
          ).toFixed(0);
        }
      if (this.posvendasScore) {
        this.setColorAS(this.posvendasScore);
      }
      this.loader = false;
    },
    reportName() {
      if (this.userAuth.companyId === '6107163db7c09a18a2663385') {
        return this.$t('reports.hgsi.scsiLabel');
      }
      return this.$t('reports.hgsi.hgsiLabel');
    },
    setColorS(percentBalance) {
      if (percentBalance >= 950) {
        this.colorBalanceS = '#6bca6c';
      } else if (percentBalance < 950 && percentBalance >= 800) {
        this.colorBalanceS = '#fbcf3f';
      } else if (percentBalance < 800) {
        this.colorBalanceS = 'red';
      }
    },
    setColorAS(percentBalance) {
      if (percentBalance >= 930) {
        this.colorBalanceAS = '#6bca6c';
      } else if (percentBalance < 930 && percentBalance >= 800) {
        this.colorBalanceAS = '#fbcf3f';
      } else if (percentBalance < 800) {
        this.colorBalanceAS = 'red';
      }
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));

    this.fields = [
      {
        key: 'question',
        label: this.$t('reports.hgsi.addQuestionLabel'),
        sortable: true,
        class: 'questionHgsi',
      },
      { key: 'progress', class: 'progressHgsi' },
      {
        key: 'score',
        label: this.$t('reports.hgsi.scoreLabel'),
        sortable: true,
        class: 'scoreHgsi',
      },
      {
        key: 'total',
        label: this.$t('reports.hgsi.totalLabel'),
        sortable: true,
        class: 'totalHgsi',
      },
    ];
  },

  mounted() {
    this.visible = !this.showCollapsed;
    if (
      this.userAuth.companyId === '6107163db7c09a18a2663385' ||
      this.userAuth.companyId === '5f69ee75a3024a4fa2416b1f'
    ) {
      if (this.userAuth.companyId === '6107163db7c09a18a2663385') {
        this.reportTitle = 'SCSI';
      } else {
        this.reportTitle = 'HGSI';
      }
      this.mountHGSI();
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/themes/default/variables.scss';

.no-padding {
  padding: 0;
}
.table {
  margin: 0;
}
.wrapper-hgsi .table > thead > tr:nth-child(2) {
  display: none;
}
.wrapper-hgsi .btn .btn-light .collapsed {
  background-color: transparent;
}
.card {
  border: 1px solid rgba(0, 0, 0, 0.09);
}
.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;

  transition: color 0.2s;

  &:hover {
    color: #1dc86e;
  }
}
.hgsi-chart {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100% - 30px);
}
</style>
<style>
.progressHgsi {
  width: 400px;
}
.scoreHgsi {
  width: 70px;
  padding-right: 0px !important;
}
.totalHgsi {
  width: 70px;
  padding-right: 0px !important;
}
.questionHgsi {
  width: calc(100% - 500px);
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/rankings/components/hgsi.vue